import { defineMessages } from 'react-intl';

const messages = defineMessages({
  name: {
    description: 'Ship from location name',
    defaultMessage: 'Location Name',
    id: '0dY9pq',
  },
  nameRequired: {
    description: 'required message for ship from location',
    defaultMessage: 'Location Name is required.',
    id: '1h+7JH',
  },
  useAsDefaultLocation: {
    description: 'Checkbox for default location',
    defaultMessage: 'Use as my default location',
    id: 'rRz2oJ',
  },
  existingDefaultLocation: {
    description: 'Checkbox for default location',
    defaultMessage: 'This is my default location',
    id: 'k5ZrV+',
  },
  parseFailTitle: {
    description: 'parseError.title',
    defaultMessage: 'Error Parsing Address',
    id: 'nkK0B1',
  },
  parseFailMessage: {
    description: 'parseError.message',
    defaultMessage: 'There was a problem parsing the pasted address. Please try again later.',
    id: 'yhiZzo',
  },
  isResidential: {
    description: 'addShipFromModal.isResidential',
    defaultMessage: 'Residential Address',
    id: 'qGYn7Q',
  },
  originAddressHeader: {
    description: 'origin address title in ship from location modal',
    defaultMessage: 'Ship From Address',
    id: 'OlPqVB',
  },
  returnAddressHeader: {
    description: 'addShipFromModal.returnAddressTitle',
    defaultMessage: 'Return Address',
    id: 'J10fCF',
  },
  sameAsShipFrom: {
    description: 'checkbox label to use ship from as return in ship from location modal',
    defaultMessage: 'Use Ship From Address as Return Address',
    id: 'bhtLVm',
  },
  saveChanges: {
    description: 'add ship from modal call to action',
    defaultMessage: 'Save',
    id: 'fKtP/j',
  },
  addShipFromModalHeader: {
    description: 'Add new ship from location modal header',
    defaultMessage: 'Add New Ship From Location',
    id: 'Vo0b1e',
  },
  editShipFromModalHeader: {
    description: 'edit ship from location modal header',
    defaultMessage: 'Edit Your Ship From Location',
    id: 'X41rpc',
  },
  cancel: {
    description: 'cancel editing/adding new ship from location',
    defaultMessage: 'Cancel',
    id: 'R6H8qC',
  },
  noInventory: {
    description: 'Ship from no Inventory',
    defaultMessage: 'None',
    id: 'Ds6/U7',
  },
  noShipFroms: {
    description: 'No shipfroms currently exist',
    defaultMessage: 'There are currently no records',
    id: 'X9RayN',
  },
  aggregateWarehouseName: {
    description: 'Default name for aggregate inventory warehouse',
    defaultMessage: 'All Stock',
    id: 'DiddA6',
  },
  externalWarehouseDropdownLabel: {
    description: 'Label for inventory source dropdown showing the external provider name next to the external source name',
    defaultMessage: '{externalInventoryProviderName} ({externalInventorySourceName})',
    id: 'kvzRwj',
  },
  shipstationInventory: {
    description: 'native intentory source warehouse group name',
    defaultMessage: 'ShipStation Inventory',
    id: 'nXbag6',
  },
  shipFromErrorMessage: {
    description: 'Error message in bulk flow to let users know they need to enter an email',
    defaultMessage: 'Ship From email address is required <link>Edit</link>',
    id: 'pZqiKk',
  },
});

export default messages;
